/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import ScrollToTop from 'react-scroll-to-top';
import { useDispatch } from 'react-redux';
import { propertiesMap } from '../redux/action';
import { nearbyPropertiesMap } from '../redux/action';
import { ReasonModal } from './ReasonModal';
import { PropertyCard } from './PropertyCard';
import { ScrollContext } from "./ScrollContext";

export const PropertySearchResultsLists = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState('');
  const [propertyID, setPropertyID] = useState('');
  const [propertyRef, setPropertyRef] = useState(null);
  const [searchParams, setSearchParams] = useState(null);
  const [properties, setProperties] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [reasonError, setReasonError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [currentLat, setCurrentLat] = useState(null);
  const [currentLon, setCurrentLon] = useState(null);
  const [nearbyDistance, setNearbyDistance] = useState(1000);
  const [userID] = useState(localStorage.getItem('userId'));
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [pageSize, setPageSize] = useState(() => {
    const savedPageSize = localStorage.getItem('PropertySearchPageSize');
    return savedPageSize ? parseInt(savedPageSize, 10) : 10;
  });
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const hasFetchedRef = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { isBottom } = React.useContext(ScrollContext);
  const prevIsBottomRef = useRef(false);

  function setPosition() {
    const scrollPos = window.scrollY;
    localStorage.setItem('PropertySearchPosition', scrollPos);
  }

  function handleScroll() {
    setPosition();
    localStorage.setItem('PropertySearchPageSize', pageSize);
  }

  const fetchData = async () => {
    console.log('fetchData called, pageSize:', pageSize);
    const saved = localStorage.getItem('properties');
    const initial = JSON.parse(saved) || {};
    const {
      residential,
      commercial,
      forsale,
      longlet,
      salePriceTo,
      salePriceFrom,
      longletPriceTo,
      longletPriceFrom,
      regionId,
      zoneId,
      propertyref,
      localityId,
      propertyTypeGroupId,
      propertyTypeId,
      propertySubtypeId,
    } = initial;

    let dataPayload = {
      propertyref: location?.state?.propertyref || propertyref,
      firstName: location?.state?.vendorName,
      vendorSurname: location?.state?.vendorSurname,
      telNo: location?.state?.vendorPhone,
      residential:
        convertStringValueToBoolean(location?.state?.residential) ||
        convertStringValueToBoolean(residential),
      commercial:
        convertStringValueToBoolean(location?.state?.commercial) ||
        convertStringValueToBoolean(commercial),
      forsale:
        convertStringValueToBoolean(location?.state?.forsale) ||
        convertStringValueToBoolean(forsale),
      longlet:
        convertStringValueToBoolean(location?.state?.longlet) ||
        convertStringValueToBoolean(longlet),
      salePriceTo:
        convertStringValueToDouble(location?.state?.salePriceTo) ||
        convertStringValueToDouble(salePriceTo),
      salePriceFrom:
        convertStringValueToDouble(location?.state?.salePriceFrom) ||
        convertStringValueToDouble(salePriceFrom),
      longletPriceTo:
        convertStringValueToDouble(location?.state?.longletPriceTo) ||
        convertStringValueToDouble(longletPriceTo),
      longletPriceFrom:
        convertStringValueToDouble(location?.state?.longletPriceFrom) ||
        convertStringValueToDouble(longletPriceFrom),
      regionId:
        convertStringValueToNumber(location?.state?.regionId) ||
        convertStringValueToNumber(regionId),
      zoneId:
        convertStringValueToNumber(location?.state?.zoneId) ||
        convertStringValueToNumber(zoneId),
      allLocalityId: location?.state?.localityId?.toString() || localityId?.toString(),
      propertyTypeGroupId:
        convertStringValueToNumber(location?.state?.propertyTypeGroupId) ||
        convertStringValueToNumber(propertyTypeGroupId),
      propertyTypeId:
        convertStringValueToNumber(location?.state?.propertyTypeId) ||
        convertStringValueToNumber(propertyTypeId),
      propertySubtypeId:
        convertStringValueToNumber(location?.state?.propertySubtypeId) ||
        convertStringValueToNumber(propertySubtypeId),
      pageSize: pageSize,
      includeImages: true,
      includeDraftProperties: false,
      leaseRatePeriodId: 3,
      onMarket: true,
    };

    setSearchParams(dataPayload);

    const options = {
      method: 'POST',
      url: '/property/search',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(dataPayload),
    };

    try {
      if (!hasFetchedRef.current) {
        setLoading(true);
      } else {
        setIsFetchingMore(true);
      }

      const response = await axios.request(options);
      setData((prevData) => {
        const newData = response.data.data.filter(
          (item) => !prevData.some((prev) => prev.id === item.id)
        );
        return [...prevData, ...newData];
      });
      dispatch(propertiesMap(response.data.data));
      setLoading(false);
      setIsFetchingMore(false);
      setIsPageLoaded(true);
      hasFetchedRef.current = true;
    } catch (error) {
      console.error(error);
      setLoading(false);
      setIsFetchingMore(false);
      // Disabled error toast per requirements
    }
  };

  useEffect(() => {
    document.title = 'Property Search Lists';
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem('properties');
    let details =
      location?.state === undefined
        ? JSON.parse(saved)
        : location?.state;
    setProperties(details);
    if (location?.state) {
      localStorage.setItem('properties', JSON.stringify(location?.state));
    }
  }, [location?.state]);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchData();
    }
  }, [location?.state]);

  useEffect(() => {
    console.log('isBottom:', isBottom, 'isPageLoaded:', isPageLoaded);
    // Trigger only on transition to bottom (false -> true) to avoid loops
    const wasBottom = prevIsBottomRef.current;
    if (isPageLoaded && isBottom && !wasBottom && !loading && !isFetchingMore) {
      setIsFetchingMore(true);
      setPageSize((prev) => {
        const newPageSize = prev + 10;
        console.log('Incrementing pageSize to:', newPageSize);
        localStorage.setItem('PropertySearchPageSize', newPageSize);
        fetchData();
        return newPageSize;
      });
    }
    prevIsBottomRef.current = isBottom;
  }, [isBottom, isPageLoaded, loading, isFetchingMore]);

  // fixmeadd: Scroll to image based on saved propertyRef
  useEffect(() => {
    if (isPageLoaded && !loading && !isFetchingMore) {
      const savedPropertyRef = localStorage.getItem('PropertySearchRef');
      if (savedPropertyRef) {
        setTimeout(() => {
          const imgElement = document.querySelector(`img[data-property-ref="${savedPropertyRef}"]`);
          if (imgElement) {
            console.log('Restoring scroll to propertyRef:', savedPropertyRef);
            imgElement.scrollIntoView({ behavior: 'auto', block: 'center' });
            localStorage.removeItem('PropertySearchRef'); // Clear after scroll
          } else {
            console.log('Image not found for propertyRef:', savedPropertyRef);
          }
        }, 100); // Small delay to ensure DOM is ready
      }
    }
  }, [isPageLoaded, loading, isFetchingMore]);

  const getCurrentLocation = function () {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  useEffect(() => {
    getCurrentLocation()
      .then((position) => {
        setCurrentLat(position.coords.latitude);
        setCurrentLon(position.coords.longitude);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleReasonChange = (event) => {
    setReasonError(null);
    setReason(event.value);
    setDescription(event.label);
  };

  const handleNearbyDistanceChange = (event) => {
    setNearbyDistance(event.target.value);
  };

  const fetchReason = () => {
    const options = {
      method: 'GET',
      url: `/propertyfavouritereason`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return {
            value: element.id,
            label: element.description,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const reasonModal = (e, id, propertyRef, localReason = null) => {
    if (localReason) {
      setReason(localReason);
    }
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
    setPropertyID(id);
    setPropertyRef(propertyRef);
  };

  const handleComment = (e) => {
    setCommentError(null);
    setComment(e.target.value);
  };

  const addFavourite = async (e) => {
    setDisabled(true);
    if (!reason) {
      setReasonError("Reason input can't be empty");
      setDisabled(false);
      return;
    }
    if (!comment) {
      setCommentError("Comment input can't be empty");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toISOString();

    const config = {
      method: 'POST',
      url: '/propertyfavourite',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        sys_UserId: userID,
        dateRegistered: isoDate,
        propertyFavouriteReasonId: reason,
        comments: comment,
      }),
    };

    try {
      const data = await axios(config);
      if (data.status == 201) {
        setReason('');
        setComment('');
        setDisabled(false);
        toast.success(
          `Property: ${propertyRef} has been added to ${description}`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowModal(false);
      }
    } catch (err) {
      if (
        err.response.status === 400 &&
        err.response.data.message ===
          'bizrule_propertyFavourite_favouriteReasonAlreadyExists'
      )
        toast.error(
          `Sorry,Property: ${propertyRef} wasn't added, It has been already added`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      if (err.response.status === 500)
        toast.error(
          `Sorry,Server error, Property: ${propertyRef} wasn't added, try again later`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      setComment('');
      setDisabled(false);
    }
  };

  const handleMap = () => {
    navigate('/Map');
  };

  const handleNearby = () => {
    getCurrentLocation();
    fetchNearbyProperties();
    navigate('/NearbyMap', {
      state: {
        currentLat: currentLat,
        currentLon: currentLon,
        radius: nearbyDistance,
      },
    });
  };

  const convertStringValueToNumber = (value) => {
    if (value) {
      return Number(value);
    }
    return null;
  };

  const convertStringValueToBoolean = (value) => {
    if (value) {
      return Boolean(value);
    }
    return null;
  };

  const convertStringValueToDouble = (value) => {
    if (value) {
      let budget = value.replaceAll(',', '');
      return parseFloat(budget);
    }
    return null;
  };

  const fetchNearbyProperties = () => {
    let data = {
      searchParams: searchParams,
      currentLat: currentLat,
      currentLon: currentLon,
      metersAway: nearbyDistance,
    };

    const options = {
      method: 'POST',
      url: '/property/SearchWithinDistance',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(options)
      .then((response) => {
        dispatch(nearbyPropertiesMap(response.data));
        setData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  let numericFormatter = new Intl.NumberFormat('en-UK', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const numberWithCommas = (x) => {
    return numericFormatter.format(x);
  };

  const { data: reasonData } = useQuery(['Reason'], fetchReason);

  if (loading) {
    return <CenteredSpinner />;
  }

  return (
    <>
      <div className="container v-100" onScroll={isPageLoaded ? handleScroll : null}>
        <ScrollToTop smooth color="#6f00ff" />
        <div className="row">
          <div className="col-9 col-md-9 col-xl-9 p-0">
            {data?.length !== 0 && data?.length > 0 ? (
              <div className="h4 mb-3 ml-0">
                Properties search returned{' '}
                {data?.length
                  ? `${data?.length} results`
                  : `${data?.length} result`}
              </div>
            ) : (
              <div className="col-12 col-md-12 col-xl-12 p-0">
                <div className="h4 mb-3 ml-0">No Results, Sorry</div>
              </div>
            )}
            {data && data?.length !== 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="h6 mb-3 ml-0 cursor-item" onClick={handleMap}>
                    Show on map <i className="fas fa-map-marked-alt"></i>
                  </div>
                </div>
              </div>
            ) : null}
            {data && data?.length !== 0 ? (
              <div className="row">
                <div className="col-5">
                  <div
                    className="h6 mb-3 mt-2 ml-0 cursor-item"
                    onClick={handleNearby}
                  >
                    Nearby Properties <i className="fas fa-map-marked-alt"></i>
                  </div>
                </div>
                <div className="col-7">
                  <select
                    className={`form-control d-block`}
                    name="nearbyDistance"
                    onChange={handleNearbyDistanceChange}
                  >
                    <option value="1000">1 Km away</option>
                    <option value="2000">2 Kms away</option>
                    <option value="3000">3 Kms away</option>
                    <option value="4000">4 Kms away</option>
                    <option value="5000">5 Kms away</option>
                    <option value="6000">6 Kms away</option>
                    <option value="7000">7 Kms away</option>
                    <option value="8000">8 Kms away</option>
                    <option value="9000">9 Kms away</option>
                    <option value="10000">10 Kms away</option>
                  </select>
                </div>
              </div>
            ) : null}
          </div>
          <div className="col-3 col-md-3 col-xl-3 text-right">
            <div
              className="btn btn-outline-secondary d-block mb-4"
              onClick={() =>
                navigate('/PropertySearch', {
                  state: {
                    commercial: location?.state?.commercial,
                    forSale: location?.state?.forsale,
                    localityId: location?.state?.localityId,
                    longlet: location?.state?.longlet,
                    longletPriceFrom: location?.state?.longletPriceFrom,
                    longletPriceTo: location?.state?.longletPriceTo,
                    propertySubtypeId: location?.state?.propertySubtypeId,
                    propertyTypeGroupId: location?.state?.propertyTypeGroupId,
                    propertyTypeId: location?.state?.propertyTypeId,
                    propertyRef: location?.state?.propertyref,
                    vendorName: location?.state?.vendorName,
                    vendorSurname: location?.state?.vendorSurname,
                    vendorPhone: location?.state?.vendorPhone,
                    regionId: location?.state?.regionId,
                    propertyUse: location?.state?.residential,
                    salePriceFrom: location?.state?.salePriceFrom,
                    salePriceTo: location?.state?.salePriceTo,
                    zoneId: location?.state?.zoneId,
                  },
                })
              }
            >
              <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
              Back
            </div>
          </div>
          <div className="container pl-0 pr-0">
            <div className="row">
              {data &&
                React.Children.toArray(
                  data?.map((property, index) => (
                    <PropertyCard
                      property={property}
                      index={index}
                      location={location}
                      showHotBtn={true}
                      showFavouriteBtn={true}
                      reasonModal={reasonModal}
                    />
                  ))
                )}

              <ReasonModal
                showModal={showModal}
                reason={reason}
                setReason={setReason}
                setReasonError={setReasonError}
                setCommentError={setCommentError}
                setShowModal={setShowModal}
                reasonError={reasonError}
                handleReasonChange={handleReasonChange}
                reasonData={reasonData}
                comment={comment}
                handleComment={handleComment}
                commentError={commentError}
                disabled={disabled}
                addFavourite={addFavourite}
              />
            </div>
            {isFetchingMore && <CenteredSpinner size={30} />}
          </div>
        </div>
      </div>
      {data?.length !== 0 ? (
        <div
          className="btn btn-outline-secondary d-block mb-4"
          onClick={() =>
            navigate('/PropertySearch', {
              state: {
                commercial: location?.state?.commercial,
                forSale: location?.state?.forsale,
                localityId: location?.state?.localityId,
                longlet: location?.state?.longlet,
                longletPriceFrom: location?.state?.longletPriceFrom,
                longletPriceTo: location?.state?.longletPriceTo,
                propertySubtypeId: location?.state?.propertySubtypeId,
                propertyTypeGroupId: location?.state?.propertyTypeGroupId,
                propertyTypeId: location?.state?.propertyTypeId,
                propertyRef: location?.state?.propertyref,
                vendorName: location?.state?.vendorName,
                vendorSurname: location?.state?.vendorSurname,
                vendorPhone: location?.state?.vendorPhone,
                regionId: location?.state?.regionId,
                propertyUse: location?.state?.residential,
                salePriceFrom: location?.state?.salePriceFrom,
                salePriceTo: location?.state?.salePriceTo,
                zoneId: location?.state?.zoneId,
              },
            })
          }
        >
          <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
          Back
        </div>
      ) : null}
    </>
  );
};
